/**
 * Expose snifferjs—function that parse userAgent
 *
 * # Documentation
 * Documentation can be found at https://github.com/wilddeer/Sniffer
 */
export const SnifferProvider = {
  provide: 'sniffer',
  useValue: require('snifferjs'),
};
